import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../../_shared/shared.module';
import { StatusEditorComponent } from './status-editor/status-editor.component';
import { StatusListComponent } from './status-list/status-list.component';
import { StatusRoutingModule } from './status-routing.module';
import { CaseCreditorStatusListComponent } from './case-creditor/status-list/status-list.component';
import {
  CaseCreditorQuickStatusEditorComponent
} from './case-creditor/case-creditor-quick-status-editor/case-creditor-quick-status-editor.component';

@NgModule({
  declarations: [
    StatusListComponent,
    StatusEditorComponent,
    CaseCreditorStatusListComponent,
    CaseCreditorQuickStatusEditorComponent,
  ],
  imports:      [
    SharedModule,
    MatAutocompleteModule,
    StatusRoutingModule,
  ],
})
export class StatusModule {
}
